import {apiDelete, apiGet, apiPost} from "../../shared/api/client";

const multipart = {headers: {"Content-Type": "multipart/form-data"}};

const compactParams = (params = {}) =>
    Object.fromEntries(
        Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== ""),
    );

const countryParams = (countryId) => ({params: compactParams({country_id: countryId})});
const countryPayload = (countryId) => (
    countryId === undefined || countryId === null || countryId === ""
        ? {}
        : {country_id: Number(countryId)}
);

export const loadContentOperationsSummary = async (countryId) =>
    apiGet("/api/v2/admin/content/operations-summary", countryParams(countryId));

export const loadNews = async ({countryId, filters = {}} = {}) => {
    const params = compactParams({
        country_id: countryId,
        search: filters.search,
        month: filters.month,
        year: filters.year,
        city: filters.city,
    });
    const hasFilters = ["search", "month", "year", "city"].some((key) => params[key] !== undefined);
    return hasFilters
        ? apiPost("/api/v2/admin/news", undefined, {params})
        : apiGet("/api/v2/admin/news", {params});
};

export const loadArchivedNews = async (countryId) =>
    apiGet("/api/v2/admin/news/archive/list", countryParams(countryId));

export const loadNewsDetail = async ({articleId, countryId}) =>
    apiGet(`/api/v2/admin/news/${articleId}`, countryParams(countryId));

export const loadBanners = async (locale, countryId) =>
    apiGet(`/api/v2/admin/banner/list/${locale}`, countryParams(countryId));

export const loadStories = async (locale, countryId) =>
    apiGet(`/api/v2/admin/story/list/${locale}`, countryParams(countryId));

export const loadSlides = async (locale) =>
    apiGet("/api/v2/admin/news/slides/list/new", {params: compactParams({locale})});

export const saveNews = async ({countryId, ...payload}) => apiPost(
    "/api/v2/admin/news/create_or_edit",
    {...payload, ...countryPayload(countryId)},
);

export const createNews = saveNews;

export const archiveNews = async (articleId) => apiPost("/api/v2/admin/news/archive", {article_id: articleId});

export const uploadBanner = async ({locale, file, countryId}) => {
    const body = new FormData();
    body.append("language", locale);
    body.append("content", file);
    if (countryId !== undefined && countryId !== null && countryId !== "") {
        body.append("country_id", String(countryId));
    }
    return apiPost("/api/v2/admin/banner/upload", body, multipart);
};

export const deleteBanner = async ({id, locale, countryId}) =>
    apiDelete(`/api/v2/admin/banner/delete/${id}/${locale}`, countryParams(countryId));

export const reorderBanners = async ({items, countryId}) =>
    apiPost("/api/v2/admin/banner/change_banners_positions", {
        places: items.map(({id}) => ({id})),
        ...countryPayload(countryId),
    });

export const uploadStory = async ({locale, file, countryId}) => {
    const body = new FormData();
    body.append("language", locale);
    body.append("content", file);
    if (countryId !== undefined && countryId !== null && countryId !== "") {
        body.append("country_id", String(countryId));
    }
    return apiPost("/api/v2/admin/story/upload", body, multipart);
};

export const uploadStoryItem = async ({storyId, file, contentType, redirectId, isLast, countryId}) => {
    const body = new FormData();
    body.append("content", file);
    if (contentType) body.append("content_type", contentType);
    if (redirectId !== undefined && redirectId !== null && redirectId !== "") {
        body.append("redirect_id", String(redirectId));
    }
    body.append("is_last", String(Boolean(isLast)));
    if (countryId !== undefined && countryId !== null && countryId !== "") {
        body.append("country_id", String(countryId));
    }
    return apiPost(`/api/v2/admin/story/${storyId}/item/upload`, body, multipart);
};

export const deleteStory = async ({id, locale, countryId}) =>
    apiDelete(`/api/v2/admin/story/delete/${id}/${locale}`, countryParams(countryId));

export const reorderStories = async ({items, countryId}) =>
    apiPost("/api/v2/admin/story/change_stories_positions", {
        places: items.map(({id}) => ({id})),
        ...countryPayload(countryId),
    });
